var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTemperatureButton(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mdpi/icon/temp-btn-default") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Walk-in/out",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mismatch",
    transform: "translate(-1438.000000, -372.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "main-panel",
    transform: "translate(79.000000, 64.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Card",
    transform: "translate(0.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Salim-mismatch-Copy",
    transform: "translate(1250.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(9.000000, 126.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/temp-btn-default",
    transform: "translate(100.000000, 136.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#5f00a0",
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    rx: 2.66666667
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(9.800000, 4.200000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/temp/green",
    transform: "translate(0.200000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.98181818,14.3870738 C8.3376784,14.8739084 9.30909091,16.1875116 9.30909091,17.7316017 C9.30909091,19.6901804 7.74615767,21.2779221 5.81818182,21.2779221 C3.89020596,21.2779221 2.32727273,19.6901804 2.32727273,17.7316017 C2.32727273,16.1875116 3.29868524,14.8739084 4.65454545,14.3870738 L4.65454545,8.27792208 L6.98181818,8.27792208 L6.98181818,14.3870738 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.32727273,13.0027417 L2.32727273,3.49090909 C2.32727273,1.56293324 3.89020596,3.54163419e-16 5.81818182,0 C7.74615767,-3.54163419e-16 9.30909091,1.56293324 9.30909091,3.49090909 L9.30909091,13.0027417 C10.7222653,14.081067 11.6363636,15.7978904 11.6363636,17.7316017 C11.6363636,20.9958995 9.03147491,23.6421356 5.81818182,23.6421356 C2.60488873,23.6421356 0,20.9958995 0,17.7316017 C0,15.7978904 0.914098383,14.081067 2.32727273,13.0027417 Z",
    id: "Combined-Shape",
    stroke: "#FFFFFF",
    strokeWidth: 0.775757576
  })))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperatureButton);
export default __webpack_public_path__ + "static/media/temperature_button.44f0694845b58d6166d54efd937ccf28.svg";
export { ForwardRef as ReactComponent };